import React from 'react';
import Buttons from './components/Buttons';
import Input from './components/Input';
import Modal from './components/Modal';
import Select from './components/Select';

function App() {
  return (
    <div>
      <Buttons />
      <Input />
      <Modal />
      <Select />
    </div>
  )
}

export default App